module.exports = __webpack_public_path__ + "img/city.221a1a54.png";